import styled from '@emotion/styled';

import theme from '@app/styles/theme';
import Table from '@app/shop/components/Table';

export const DetailTable = styled(Table)`
  & tbody {
    & th {
      font-weight: normal;
      text-align: left;
    }

    & td,
    & th {
      border-bottom: 1px solid ${theme.colors.lightGray};
    }
  }
`;

DetailTable.defaultProps = { alternateRows: false };
